const appPaths = {
    casework: {
        dashboard: '/casework/dashboard',
        referrals: '/casework/referrals',
        quotes: '/casework/quotes',
        quote: '/casework/quote/:referralId',
        bookings: '/casework/bookings',
        timesheets: '/casework/timesheets',
        timesheet: '/casework/timesheet',
    },
    members: {
        profile: '/members/profile',
        invite: '/members/invite',
        calendar: '/members/calendar',
        approve: '/members/approve',
        preferences: '/members/preferences'
    },
    admin: {
        organizations: '/admin/organizations',
        organization: '/admin/organization/:id',
        newOrganization: '/admin/organization',
        members: '/admin/members'
    }
}

export default appPaths;